<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">搬入予定（日付別）出力</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="submit">出力</v-btn>
        <v-btn @click="show=false">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field label="納入場所" v-model="query.warehouse1"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="納入場所" v-model="query.warehouse2"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="納入場所" v-model="query.warehouse3"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md6 pr-2>
                <date-picker :label="$t('app.labels.eta')" v-model="query.etaFrom"></date-picker>
              </v-flex>
              <v-flex md6 pl-2>
                <date-picker :min="query.etaFrom" label="~" v-model="query.etaTo"></date-picker>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-select :items="status" label="ステータス" v-model="query.status"></v-select>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      status: ['納入指示済', '受入確認済'],
      show: false,
      query: {},
      resolve: null,
      reject: null
    }
  },
  methods: {
    popup() {
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    submit() {
      this.show = false
      this.resolve(this.query)
    }
  }
}
</script>
